import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["categories", "primary"]

  connect() {
    this.sync()
  }

  sync() {
    if (!this.hasCategoriesTarget || !this.hasPrimaryTarget) return

    const selectedOptions = Array.from(this.categoriesTarget.selectedOptions)
      .filter(option => option.value)
      .map(option => ({ value: option.value, text: option.text.trim() }))

    const currentValue = this.primaryTarget.value
    const nextValue = selectedOptions.some(option => option.value === currentValue)
      ? currentValue
      : (selectedOptions[0]?.value || "")

    this.updatePrimarySelect(selectedOptions, nextValue)
  }

  updatePrimarySelect(options, value) {
    const tom = this.primaryTarget.tomselect
    const shouldDisable = options.length === 0

    if (tom) {
      tom.clear(true)
      tom.clearOptions()
      options.forEach(option => tom.addOption(option))
      tom.refreshOptions(false)
      tom.setValue(value, true)
      this.primaryTarget.disabled = shouldDisable
      if (shouldDisable) {
        tom.disable()
      } else {
        tom.enable()
      }
      tom.inputState()
      return
    }

    this.primaryTarget.innerHTML = ""

    options.forEach(option => {
      const el = document.createElement("option")
      el.value = option.value
      el.textContent = option.text
      this.primaryTarget.appendChild(el)
    })

    this.primaryTarget.value = value
    this.primaryTarget.disabled = shouldDisable
  }
}
